import './header.css'

const Header = () => {
    return ( 
        <>
            <div className="header">
                <h1>Visiting Card Scanner</h1>  
            </div>
        </>
     );
}
 
export default Header;